import React, { useEffect } from "react";
import useDesktopSize from "../../utils/hooks/useDesktopSize";
import HorizontalNavBar from "./HorizontalNavBar";
import VerticalNavBar from "./VerticalNavBar";
import "./Navigation.scss";
import MobileNavBar from "./MobileNavBar";
import useShowNavBar from "./hooks/useShowNavBar";
import useFacility from "../../utils/hooks/useFacility";
import ReactPixel from "react-facebook-pixel";
import SimplifiedNavBar from "./SimplifiedNavBar";

interface NavBarProps {
  layout: "horizontal" | "vertical" | "simplified";
}

const NavBar: React.FC<NavBarProps> = ({ layout }) => {
  const isDesktop = useDesktopSize();
  const showNavBar = useShowNavBar();
  const facilityIds = useFacility();

  useEffect(() => {
    if (
      facilityIds === "273" ||
      facilityIds === "1224" ||
      facilityIds === "1200" ||
      facilityIds === "1204" ||
      facilityIds === "1227" ||
      facilityIds === "1214"
    ) {
      ReactPixel.pageView();
    }
    //eslint-disable-next-line
  }, []);

  if (!showNavBar) {
    return <></>;
  }

  if (layout === "simplified") {
    return <SimplifiedNavBar />;
  }

  if (!isDesktop) {
    return <MobileNavBar />;
  }

  if (layout === "horizontal") {
    return <HorizontalNavBar />;
  }

  return <VerticalNavBar />;
};

export default NavBar;
